import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Components
import { DgoComponent } from 'src/app/modules/public/views/dgo/dgo.component';
import { LoginComponent } from './platform/views/login/login.component';
import { SummaryComponent } from 'src/app/modules/summary/views/summary/summary.component';
import { AccountComponent } from 'src/app/modules/account/views/account/account.component';
import { PaymentsComponent } from 'src/app/modules/payments/views/payments/payments.component';
import { PaymentsStatusComponent } from 'src/app/modules/payments/views/payments-status/payments-status.component';
import { ProductsComponent } from 'src/app/modules/products/views/products/products.component';
import { InvoicesComponent } from 'src/app/modules/invoices/views/invoices/invoices.component';
import { InvoicesCallsListComponent } from 'src/app/modules/invoices/views/invoices-calls-list/invoices-calls-list.component';
import { ProceduresComponent } from 'src/app/modules/procedures/views/procedures/procedures.component';

const routes: Routes = [
  { path: '', component: LoginComponent, data: { title: 'Ingresar' } },
  { path: 'dgo', component: DgoComponent, data: { title: 'Iptel - DGo' } },
  { path: 'ingreso', component: LoginComponent, data: { title: 'Ingresar' } },
  { path: 'recuperar', component: LoginComponent, data: { title: 'Recupera contraseña' } },
  { path: 'restablecer', component: LoginComponent, data: { title: 'Restablecer contraseña' } },
  { path: 'registro', component: LoginComponent, data: { title: 'Activar cuenta' } },
  { path: 'resumen', component: SummaryComponent, data: { title: 'Resumen de cuenta' } },
  { path: 'cuenta', component: AccountComponent, data: { title: 'Mis datos' } },
  { path: 'pagos', component: PaymentsComponent, data: { title: 'Mis pagos' } },
  { path: 'pagos/pago', component: PaymentsStatusComponent, data: { title: 'Estado del pago' } },
  { path: 'gestiones', component: ProceduresComponent, data: { title: 'Mis gestiones' } },
  { path: 'productos-contratados', component: ProductsComponent, data: { title: 'Productos contratados' } },
  { path: 'facturas', component: InvoicesComponent, data: { title: 'Mis facturas' } },
  { path: 'facturas/:invoiceId/:invoiceType/llamadas', component: InvoicesCallsListComponent, data: { title: 'Llamadas facturadas' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
